import React, {
  useEffect,
  useState,
} from "react";

import {
  FaArrowLeft,
  FaPhone,
  FaShieldAlt,
  FaCheckCircle,
  FaSpinner,
  FaSave,
  FaMobileAlt,
  FaLock,
  FaNetworkWired,
  FaPlus,
} from "react-icons/fa";

import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import {
  useNavigate,
} from "react-router-dom";

import {
  db,
} from "../firebase";

import "./AddCard.css";


const ADD_CARD_TRANSLATIONS = {
  "en": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Phone Wallet",
    "Security setup required": "Security setup required",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Complete Profile",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Required",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Optional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Saved",
    "Pending": "Pending",
    "Added": "Added",
    "Saving...": "Saving...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Go back",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "sw": {
    "Checking security information...": "Inakagua taarifa za usalama...",
    "Phone Wallet": "Pochi ya Simu",
    "Security setup required": "Usanidi wa usalama unahitajika",
    "Redirecting to Profile": "Inaelekeza kwenye Wasifu",
    "You will be redirected automatically in": "Utaelekezwa kiotomatiki baada ya",
    "seconds": "sekunde",
    "Complete your security information there.": "Kamilisha taarifa zako za usalama hapo.",
    "Complete Profile": "Kamilisha Wasifu",
    "Mobile payment information": "Taarifa za malipo ya simu",
    "Complete Your Security Profile": "Kamilisha Wasifu Wako wa Usalama",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Kabla ya kuongeza pochi ya simu, tafadhali kamilisha taarifa zinazohitajika za usalama kwenye wasifu wako.",
    "Real Name": "Jina Halisi",
    "Required": "Inahitajika",
    "Withdrawal Password": "Nenosiri la Kutoa Pesa",
    "Security Question & Answer": "Swali na Jibu la Usalama",
    "Phone Wallet Fully Secured": "Pochi ya Simu Imelindwa Kikamilifu",
    "All wallet information has been securely saved.": "Taarifa zote za pochi zimehifadhiwa kwa usalama.",
    "Primary Phone Number": "Nambari Kuu ya Simu",
    "Primary Network": "Mtandao Mkuu",
    "Second Phone Number": "Nambari ya Pili ya Simu",
    "Second Network": "Mtandao wa Pili",
    "Fully Secured": "Imelindwa Kikamilifu",
    "Primary number, primary network, second number and second network are saved.": "Nambari kuu, mtandao mkuu, nambari ya pili na mtandao wa pili vimehifadhiwa.",
    "This wallet information is secured and cannot be edited.": "Taarifa hizi za pochi zimelindwa na haziwezi kuhaririwa.",
    "Wallet Setup Progress": "Maendeleo ya Usanidi wa Pochi",
    "Your saved wallet information is protected.": "Taarifa zako za pochi zilizohifadhiwa zinalindwa.",
    "Primary Number": "Nambari Kuu",
    "Not selected": "Haijachaguliwa",
    "Second Number": "Nambari ya Pili",
    "Not added": "Haijaongezwa",
    "Security Verification": "Uthibitishaji wa Usalama",
    "Please answer your security question before adding your phone wallet.": "Tafadhali jibu swali lako la usalama kabla ya kuongeza pochi ya simu.",
    "Your Answer": "Jibu Lako",
    "Enter your answer": "Ingiza jibu lako",
    "Verify Security": "Thibitisha Usalama",
    "Security Verified": "Usalama Umethibitishwa",
    "You can now add your phone wallet.": "Sasa unaweza kuongeza pochi ya simu.",
    "Secured": "Imelindwa",
    "Optional": "Hiari",
    "Primary number is already secured and cannot be changed.": "Nambari kuu tayari imelindwa na haiwezi kubadilishwa.",
    "Select your network": "Chagua mtandao wako",
    "You can add this number now or later.": "Unaweza kuongeza nambari hii sasa au baadaye.",
    "Select network for second number": "Chagua mtandao wa nambari ya pili",
    "Select the network used by your second number.": "Chagua mtandao unaotumiwa na nambari yako ya pili.",
    "Add a second number first.": "Ongeza nambari ya pili kwanza.",
    "Add Second Number": "Ongeza Nambari ya Pili",
    "You can add another phone number with its own mobile network.": "Unaweza kuongeza nambari nyingine ya simu yenye mtandao wake.",
    "Wallet Security Status": "Hali ya Usalama wa Pochi",
    "Saved": "Imehifadhiwa",
    "Pending": "Inasubiri",
    "Added": "Imeongezwa",
    "Saving...": "Inahifadhi...",
    "Save Phone Wallet": "Hifadhi Pochi ya Simu",
    "Save Primary Network": "Hifadhi Mtandao Mkuu",
    "Save Second Network": "Hifadhi Mtandao wa Pili",
    "Save Wallet Information": "Hifadhi Taarifa za Pochi",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Nambari yako kuu na mtandao wake vimelindwa. Unaweza kurudi wakati wowote kuongeza nambari ya pili na kuchagua mtandao wake.",
    "Go back": "Rudi nyuma",
    "Failed to load wallet information.": "Imeshindwa kupakia taarifa za pochi.",
    "Security information is unavailable.": "Taarifa za usalama hazipatikani.",
    "Please enter your security answer.": "Tafadhali ingiza jibu lako la usalama.",
    "Incorrect security answer. Please try again.": "Jibu la usalama si sahihi. Tafadhali jaribu tena.",
    "Security verified successfully.": "Usalama umethibitishwa kwa mafanikio.",
    "Please log in again.": "Tafadhali ingia tena.",
    "Please complete your security profile first.": "Tafadhali kamilisha kwanza wasifu wako wa usalama.",
    "Please complete security verification first.": "Tafadhali kamilisha kwanza uthibitishaji wa usalama.",
    "Please enter your primary phone number.": "Tafadhali ingiza nambari yako kuu ya simu.",
    "Please enter a valid primary phone number.": "Tafadhali ingiza nambari kuu ya simu iliyo sahihi.",
    "Please select the network for your primary phone number.": "Tafadhali chagua mtandao wa nambari yako kuu ya simu.",
    "Please enter a valid second phone number.": "Tafadhali ingiza nambari ya pili ya simu iliyo sahihi.",
    "The second phone number must be different from the primary number.": "Nambari ya pili lazima iwe tofauti na nambari kuu.",
    "Please select the network for your second phone number.": "Tafadhali chagua mtandao wa nambari yako ya pili.",
    "Phone wallet fully secured successfully.": "Pochi ya simu imelindwa kikamilifu.",
    "Primary number and network saved. You can add a second number anytime.": "Nambari kuu na mtandao vimehifadhiwa. Unaweza kuongeza nambari ya pili wakati wowote.",
    "Primary number saved. Please select its mobile network.": "Nambari kuu imehifadhiwa. Tafadhali chagua mtandao wake.",
    "Second number saved. Please select its mobile network.": "Nambari ya pili imehifadhiwa. Tafadhali chagua mtandao wake.",
    "Phone wallet information saved successfully.": "Taarifa za pochi ya simu zimehifadhiwa kwa mafanikio.",
    "Failed to save phone wallet information. Please try again.": "Imeshindwa kuhifadhi taarifa za pochi ya simu. Tafadhali jaribu tena."
  },
  "pt": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Carteira Telefônica",
    "Security setup required": "Configuração de segurança necessária",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Completar perfil",
    "Mobile payment information": "Informações de pagamento móvel",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nome verdadeiro",
    "Required": "Obrigatório",
    "Withdrawal Password": "Senha de saque",
    "Security Question & Answer": "Pergunta e resposta de segurança",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Número de telefone principal",
    "Primary Network": "Rede principal",
    "Second Phone Number": "Segundo número de telefone",
    "Second Network": "Segunda rede",
    "Fully Secured": "Totalmente protegido",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Verificação de segurança",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Sua resposta",
    "Enter your answer": "Digite sua resposta",
    "Verify Security": "Verificar segurança",
    "Security Verified": "Segurança verificada",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Protegido",
    "Optional": "Opcional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Selecione sua rede",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Adicionar segundo número",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Status de segurança da carteira",
    "Saved": "Salvo",
    "Pending": "Pendente",
    "Added": "Adicionado",
    "Saving...": "Salvando...",
    "Save Phone Wallet": "Salvar carteira telefônica",
    "Save Primary Network": "Salvar rede principal",
    "Save Second Network": "Salvar segunda rede",
    "Save Wallet Information": "Salvar informações da carteira",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Voltar",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "fr": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Portefeuille téléphonique",
    "Security setup required": "Configuration de sécurité requise",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Compléter le profil",
    "Mobile payment information": "Informations de paiement mobile",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nom réel",
    "Required": "Obligatoire",
    "Withdrawal Password": "Mot de passe de retrait",
    "Security Question & Answer": "Question et réponse de sécurité",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Numéro de téléphone principal",
    "Primary Network": "Réseau principal",
    "Second Phone Number": "Deuxième numéro de téléphone",
    "Second Network": "Deuxième réseau",
    "Fully Secured": "Entièrement sécurisé",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Vérification de sécurité",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Votre réponse",
    "Enter your answer": "Saisissez votre réponse",
    "Verify Security": "Vérifier la sécurité",
    "Security Verified": "Sécurité vérifiée",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Sécurisé",
    "Optional": "Facultatif",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Sélectionnez votre réseau",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Ajouter un deuxième numéro",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "État de sécurité du portefeuille",
    "Saved": "Enregistré",
    "Pending": "En attente",
    "Added": "Ajouté",
    "Saving...": "Enregistrement...",
    "Save Phone Wallet": "Enregistrer le portefeuille",
    "Save Primary Network": "Enregistrer le réseau principal",
    "Save Second Network": "Enregistrer le deuxième réseau",
    "Save Wallet Information": "Enregistrer les informations",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Retour",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "es": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Billetera telefónica",
    "Security setup required": "Se requiere configuración de seguridad",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Completar perfil",
    "Mobile payment information": "Información de pago móvil",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nombre real",
    "Required": "Obligatorio",
    "Withdrawal Password": "Contraseña de retiro",
    "Security Question & Answer": "Pregunta y respuesta de seguridad",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Número de teléfono principal",
    "Primary Network": "Red principal",
    "Second Phone Number": "Segundo número de teléfono",
    "Second Network": "Segunda red",
    "Fully Secured": "Totalmente protegido",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Verificación de seguridad",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Tu respuesta",
    "Enter your answer": "Introduce tu respuesta",
    "Verify Security": "Verificar seguridad",
    "Security Verified": "Seguridad verificada",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Protegido",
    "Optional": "Opcional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Selecciona tu red",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Añadir segundo número",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Estado de seguridad de la billetera",
    "Saved": "Guardado",
    "Pending": "Pendiente",
    "Added": "Añadido",
    "Saving...": "Guardando...",
    "Save Phone Wallet": "Guardar billetera",
    "Save Primary Network": "Guardar red principal",
    "Save Second Network": "Guardar segunda red",
    "Save Wallet Information": "Guardar información",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Volver",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "pt-AO": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Carteira Telefônica",
    "Security setup required": "Configuração de segurança necessária",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Completar perfil",
    "Mobile payment information": "Informações de pagamento móvel",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nome verdadeiro",
    "Required": "Obrigatório",
    "Withdrawal Password": "Senha de saque",
    "Security Question & Answer": "Pergunta e resposta de segurança",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Número de telefone principal",
    "Primary Network": "Rede principal",
    "Second Phone Number": "Segundo número de telefone",
    "Second Network": "Segunda rede",
    "Fully Secured": "Totalmente protegido",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Verificação de segurança",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Sua resposta",
    "Enter your answer": "Digite sua resposta",
    "Verify Security": "Verificar segurança",
    "Security Verified": "Segurança verificada",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Protegido",
    "Optional": "Opcional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Selecione sua rede",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Adicionar segundo número",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Status de segurança da carteira",
    "Saved": "Salvo",
    "Pending": "Pendente",
    "Added": "Adicionado",
    "Saving...": "Salvando...",
    "Save Phone Wallet": "Salvar carteira telefônica",
    "Save Primary Network": "Salvar rede principal",
    "Save Second Network": "Salvar segunda rede",
    "Save Wallet Information": "Salvar informações da carteira",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Voltar",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ar": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "محفظة الهاتف",
    "Security setup required": "يلزم إعداد الأمان",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "إكمال الملف الشخصي",
    "Mobile payment information": "معلومات الدفع عبر الهاتف",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "الاسم الحقيقي",
    "Required": "مطلوب",
    "Withdrawal Password": "كلمة مرور السحب",
    "Security Question & Answer": "سؤال الأمان وإجابته",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "رقم الهاتف الأساسي",
    "Primary Network": "الشبكة الأساسية",
    "Second Phone Number": "رقم الهاتف الثاني",
    "Second Network": "الشبكة الثانية",
    "Fully Secured": "مؤمّن بالكامل",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "التحقق الأمني",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "إجابتك",
    "Enter your answer": "أدخل إجابتك",
    "Verify Security": "تحقق من الأمان",
    "Security Verified": "تم التحقق من الأمان",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "مؤمّن",
    "Optional": "اختياري",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "اختر شبكتك",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "إضافة رقم ثانٍ",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "حالة أمان المحفظة",
    "Saved": "تم الحفظ",
    "Pending": "قيد الانتظار",
    "Added": "تمت الإضافة",
    "Saving...": "جارٍ الحفظ...",
    "Save Phone Wallet": "حفظ محفظة الهاتف",
    "Save Primary Network": "حفظ الشبكة الأساسية",
    "Save Second Network": "حفظ الشبكة الثانية",
    "Save Wallet Information": "حفظ معلومات المحفظة",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "رجوع",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "zh": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "手机钱包",
    "Security setup required": "需要设置安全信息",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "完善资料",
    "Mobile payment information": "移动支付信息",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "真实姓名",
    "Required": "必填",
    "Withdrawal Password": "提现密码",
    "Security Question & Answer": "安全问题与答案",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "主要电话号码",
    "Primary Network": "主要网络",
    "Second Phone Number": "第二个电话号码",
    "Second Network": "第二网络",
    "Fully Secured": "已完全保护",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "安全验证",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "你的答案",
    "Enter your answer": "输入答案",
    "Verify Security": "验证安全信息",
    "Security Verified": "安全验证成功",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "已保护",
    "Optional": "可选",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "选择网络",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "添加第二个号码",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "钱包安全状态",
    "Saved": "已保存",
    "Pending": "待处理",
    "Added": "已添加",
    "Saving...": "正在保存...",
    "Save Phone Wallet": "保存手机钱包",
    "Save Primary Network": "保存主要网络",
    "Save Second Network": "保存第二网络",
    "Save Wallet Information": "保存钱包信息",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "返回",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "hi": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "फोन वॉलेट",
    "Security setup required": "सुरक्षा सेटअप आवश्यक है",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "प्रोफ़ाइल पूरी करें",
    "Mobile payment information": "मोबाइल भुगतान जानकारी",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "वास्तविक नाम",
    "Required": "आवश्यक",
    "Withdrawal Password": "निकासी पासवर्ड",
    "Security Question & Answer": "सुरक्षा प्रश्न और उत्तर",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "प्राथमिक फ़ोन नंबर",
    "Primary Network": "प्राथमिक नेटवर्क",
    "Second Phone Number": "दूसरा फ़ोन नंबर",
    "Second Network": "दूसरा नेटवर्क",
    "Fully Secured": "पूरी तरह सुरक्षित",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "सुरक्षा सत्यापन",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "आपका उत्तर",
    "Enter your answer": "अपना उत्तर दर्ज करें",
    "Verify Security": "सुरक्षा सत्यापित करें",
    "Security Verified": "सुरक्षा सत्यापित",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "सुरक्षित",
    "Optional": "वैकल्पिक",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "अपना नेटवर्क चुनें",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "दूसरा नंबर जोड़ें",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "वॉलेट सुरक्षा स्थिति",
    "Saved": "सहेजा गया",
    "Pending": "लंबित",
    "Added": "जोड़ा गया",
    "Saving...": "सहेज रहा है...",
    "Save Phone Wallet": "फोन वॉलेट सहेजें",
    "Save Primary Network": "प्राथमिक नेटवर्क सहेजें",
    "Save Second Network": "दूसरा नेटवर्क सहेजें",
    "Save Wallet Information": "वॉलेट जानकारी सहेजें",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "वापस जाएँ",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "bn": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "ফোন ওয়ালেট",
    "Security setup required": "নিরাপত্তা সেটআপ প্রয়োজন",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "প্রোফাইল সম্পূর্ণ করুন",
    "Mobile payment information": "মোবাইল পেমেন্ট তথ্য",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "আসল নাম",
    "Required": "প্রয়োজনীয়",
    "Withdrawal Password": "উত্তোলন পাসওয়ার্ড",
    "Security Question & Answer": "নিরাপত্তা প্রশ্ন ও উত্তর",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "প্রাথমিক ফোন নম্বর",
    "Primary Network": "প্রাথমিক নেটওয়ার্ক",
    "Second Phone Number": "দ্বিতীয় ফোন নম্বর",
    "Second Network": "দ্বিতীয় নেটওয়ার্ক",
    "Fully Secured": "সম্পূর্ণ সুরক্ষিত",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "নিরাপত্তা যাচাই",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "আপনার উত্তর",
    "Enter your answer": "আপনার উত্তর লিখুন",
    "Verify Security": "নিরাপত্তা যাচাই করুন",
    "Security Verified": "নিরাপত্তা যাচাই হয়েছে",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "সুরক্ষিত",
    "Optional": "ঐচ্ছিক",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "নেটওয়ার্ক নির্বাচন করুন",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "দ্বিতীয় নম্বর যোগ করুন",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "ওয়ালেট নিরাপত্তার অবস্থা",
    "Saved": "সংরক্ষিত",
    "Pending": "অপেক্ষমাণ",
    "Added": "যোগ করা হয়েছে",
    "Saving...": "সংরক্ষণ হচ্ছে...",
    "Save Phone Wallet": "ফোন ওয়ালেট সংরক্ষণ করুন",
    "Save Primary Network": "প্রাথমিক নেটওয়ার্ক সংরক্ষণ",
    "Save Second Network": "দ্বিতীয় নেটওয়ার্ক সংরক্ষণ",
    "Save Wallet Information": "ওয়ালেট তথ্য সংরক্ষণ",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "ফিরে যান",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ru": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Телефонный кошелёк",
    "Security setup required": "Требуется настройка безопасности",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Заполнить профиль",
    "Mobile payment information": "Информация о мобильных платежах",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Настоящее имя",
    "Required": "Обязательно",
    "Withdrawal Password": "Пароль вывода",
    "Security Question & Answer": "Контрольный вопрос и ответ",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Основной номер телефона",
    "Primary Network": "Основная сеть",
    "Second Phone Number": "Второй номер телефона",
    "Second Network": "Вторая сеть",
    "Fully Secured": "Полностью защищено",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Проверка безопасности",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Ваш ответ",
    "Enter your answer": "Введите ответ",
    "Verify Security": "Проверить безопасность",
    "Security Verified": "Безопасность подтверждена",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Защищено",
    "Optional": "Необязательно",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Выберите сеть",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Добавить второй номер",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Статус безопасности кошелька",
    "Saved": "Сохранено",
    "Pending": "Ожидает",
    "Added": "Добавлено",
    "Saving...": "Сохранение...",
    "Save Phone Wallet": "Сохранить кошелёк",
    "Save Primary Network": "Сохранить основную сеть",
    "Save Second Network": "Сохранить вторую сеть",
    "Save Wallet Information": "Сохранить данные кошелька",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Назад",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "de": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Telefon-Wallet",
    "Security setup required": "Sicherheitseinrichtung erforderlich",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Profil vervollständigen",
    "Mobile payment information": "Mobile Zahlungsinformationen",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Echter Name",
    "Required": "Erforderlich",
    "Withdrawal Password": "Auszahlungskennwort",
    "Security Question & Answer": "Sicherheitsfrage und -antwort",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primäre Telefonnummer",
    "Primary Network": "Primäres Netzwerk",
    "Second Phone Number": "Zweite Telefonnummer",
    "Second Network": "Zweites Netzwerk",
    "Fully Secured": "Vollständig gesichert",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Sicherheitsprüfung",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Deine Antwort",
    "Enter your answer": "Antwort eingeben",
    "Verify Security": "Sicherheit überprüfen",
    "Security Verified": "Sicherheit bestätigt",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Gesichert",
    "Optional": "Optional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Netzwerk auswählen",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Zweite Nummer hinzufügen",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet-Sicherheitsstatus",
    "Saved": "Gespeichert",
    "Pending": "Ausstehend",
    "Added": "Hinzugefügt",
    "Saving...": "Speichern...",
    "Save Phone Wallet": "Telefon-Wallet speichern",
    "Save Primary Network": "Primäres Netzwerk speichern",
    "Save Second Network": "Zweites Netzwerk speichern",
    "Save Wallet Information": "Wallet-Informationen speichern",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Zurück",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "it": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Portafoglio telefonico",
    "Security setup required": "Configurazione di sicurezza richiesta",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Completa profilo",
    "Mobile payment information": "Informazioni di pagamento mobile",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nome reale",
    "Required": "Obbligatorio",
    "Withdrawal Password": "Password di prelievo",
    "Security Question & Answer": "Domanda e risposta di sicurezza",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Numero di telefono principale",
    "Primary Network": "Rete principale",
    "Second Phone Number": "Secondo numero di telefono",
    "Second Network": "Seconda rete",
    "Fully Secured": "Completamente protetto",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Verifica di sicurezza",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "La tua risposta",
    "Enter your answer": "Inserisci la risposta",
    "Verify Security": "Verifica sicurezza",
    "Security Verified": "Sicurezza verificata",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Protetto",
    "Optional": "Facoltativo",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Seleziona la rete",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Aggiungi secondo numero",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Stato di sicurezza del portafoglio",
    "Saved": "Salvato",
    "Pending": "In sospeso",
    "Added": "Aggiunto",
    "Saving...": "Salvataggio...",
    "Save Phone Wallet": "Salva portafoglio",
    "Save Primary Network": "Salva rete principale",
    "Save Second Network": "Salva seconda rete",
    "Save Wallet Information": "Salva informazioni",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Indietro",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "nl": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Telefoonportemonnee",
    "Security setup required": "Beveiligingsinstelling vereist",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Profiel voltooien",
    "Mobile payment information": "Mobiele betaalinformatie",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Echte naam",
    "Required": "Verplicht",
    "Withdrawal Password": "Opnamewachtwoord",
    "Security Question & Answer": "Beveiligingsvraag en antwoord",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primair telefoonnummer",
    "Primary Network": "Primair netwerk",
    "Second Phone Number": "Tweede telefoonnummer",
    "Second Network": "Tweede netwerk",
    "Fully Secured": "Volledig beveiligd",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Beveiligingscontrole",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Jouw antwoord",
    "Enter your answer": "Voer je antwoord in",
    "Verify Security": "Beveiliging verifiëren",
    "Security Verified": "Beveiliging geverifieerd",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Beveiligd",
    "Optional": "Optioneel",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Selecteer je netwerk",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Tweede nummer toevoegen",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Beveiligingsstatus portemonnee",
    "Saved": "Opgeslagen",
    "Pending": "In behandeling",
    "Added": "Toegevoegd",
    "Saving...": "Opslaan...",
    "Save Phone Wallet": "Telefoonportemonnee opslaan",
    "Save Primary Network": "Primair netwerk opslaan",
    "Save Second Network": "Tweede netwerk opslaan",
    "Save Wallet Information": "Portemonneegegevens opslaan",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Terug",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "tr": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Telefon Cüzdanı",
    "Security setup required": "Güvenlik kurulumu gerekli",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Profili tamamla",
    "Mobile payment information": "Mobil ödeme bilgileri",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Gerçek ad",
    "Required": "Gerekli",
    "Withdrawal Password": "Para çekme şifresi",
    "Security Question & Answer": "Güvenlik sorusu ve yanıtı",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Birincil telefon numarası",
    "Primary Network": "Birincil ağ",
    "Second Phone Number": "İkinci telefon numarası",
    "Second Network": "İkinci ağ",
    "Fully Secured": "Tamamen güvenli",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Güvenlik doğrulaması",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Yanıtınız",
    "Enter your answer": "Yanıtınızı girin",
    "Verify Security": "Güvenliği doğrula",
    "Security Verified": "Güvenlik doğrulandı",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Güvende",
    "Optional": "İsteğe bağlı",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Ağınızı seçin",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "İkinci numara ekle",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Cüzdan güvenlik durumu",
    "Saved": "Kaydedildi",
    "Pending": "Bekliyor",
    "Added": "Eklendi",
    "Saving...": "Kaydediliyor...",
    "Save Phone Wallet": "Telefon cüzdanını kaydet",
    "Save Primary Network": "Birincil ağı kaydet",
    "Save Second Network": "İkinci ağı kaydet",
    "Save Wallet Information": "Cüzdan bilgilerini kaydet",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Geri",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ja": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "電話ウォレット",
    "Security setup required": "セキュリティ設定が必要です",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "プロフィールを完成",
    "Mobile payment information": "モバイル決済情報",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "本名",
    "Required": "必須",
    "Withdrawal Password": "出金パスワード",
    "Security Question & Answer": "セキュリティ質問と回答",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "メインの電話番号",
    "Primary Network": "メインネットワーク",
    "Second Phone Number": "2つ目の電話番号",
    "Second Network": "2つ目のネットワーク",
    "Fully Secured": "完全に保護済み",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "セキュリティ確認",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "回答",
    "Enter your answer": "回答を入力",
    "Verify Security": "セキュリティを確認",
    "Security Verified": "確認済み",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "保護済み",
    "Optional": "任意",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "ネットワークを選択",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "2つ目の番号を追加",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "ウォレットの安全状態",
    "Saved": "保存済み",
    "Pending": "保留中",
    "Added": "追加済み",
    "Saving...": "保存中...",
    "Save Phone Wallet": "電話ウォレットを保存",
    "Save Primary Network": "メインネットワークを保存",
    "Save Second Network": "2つ目のネットワークを保存",
    "Save Wallet Information": "ウォレット情報を保存",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "戻る",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ko": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "휴대폰 지갑",
    "Security setup required": "보안 설정 필요",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "프로필 완료",
    "Mobile payment information": "모바일 결제 정보",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "실명",
    "Required": "필수",
    "Withdrawal Password": "출금 비밀번호",
    "Security Question & Answer": "보안 질문 및 답변",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "기본 전화번호",
    "Primary Network": "기본 네트워크",
    "Second Phone Number": "두 번째 전화번호",
    "Second Network": "두 번째 네트워크",
    "Fully Secured": "완전히 보호됨",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "보안 확인",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "답변",
    "Enter your answer": "답변 입력",
    "Verify Security": "보안 확인",
    "Security Verified": "보안 확인 완료",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "보호됨",
    "Optional": "선택 사항",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "네트워크 선택",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "두 번째 번호 추가",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "지갑 보안 상태",
    "Saved": "저장됨",
    "Pending": "대기 중",
    "Added": "추가됨",
    "Saving...": "저장 중...",
    "Save Phone Wallet": "휴대폰 지갑 저장",
    "Save Primary Network": "기본 네트워크 저장",
    "Save Second Network": "두 번째 네트워크 저장",
    "Save Wallet Information": "지갑 정보 저장",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "뒤로",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "vi": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Ví điện thoại",
    "Security setup required": "Cần thiết lập bảo mật",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Hoàn tất hồ sơ",
    "Mobile payment information": "Thông tin thanh toán di động",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Tên thật",
    "Required": "Bắt buộc",
    "Withdrawal Password": "Mật khẩu rút tiền",
    "Security Question & Answer": "Câu hỏi và câu trả lời bảo mật",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Số điện thoại chính",
    "Primary Network": "Mạng chính",
    "Second Phone Number": "Số điện thoại thứ hai",
    "Second Network": "Mạng thứ hai",
    "Fully Secured": "Được bảo mật hoàn toàn",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Xác minh bảo mật",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Câu trả lời của bạn",
    "Enter your answer": "Nhập câu trả lời",
    "Verify Security": "Xác minh bảo mật",
    "Security Verified": "Đã xác minh bảo mật",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Đã bảo mật",
    "Optional": "Tùy chọn",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Chọn mạng",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Thêm số thứ hai",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Trạng thái bảo mật ví",
    "Saved": "Đã lưu",
    "Pending": "Đang chờ",
    "Added": "Đã thêm",
    "Saving...": "Đang lưu...",
    "Save Phone Wallet": "Lưu ví điện thoại",
    "Save Primary Network": "Lưu mạng chính",
    "Save Second Network": "Lưu mạng thứ hai",
    "Save Wallet Information": "Lưu thông tin ví",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Quay lại",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "th": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Phone Wallet",
    "Security setup required": "Security setup required",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Complete Profile",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Required",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Optional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Saved",
    "Pending": "Pending",
    "Added": "Added",
    "Saving...": "Saving...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Go back",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "id": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Dompet Telepon",
    "Security setup required": "Pengaturan keamanan diperlukan",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Lengkapi profil",
    "Mobile payment information": "Informasi pembayaran seluler",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nama asli",
    "Required": "Wajib",
    "Withdrawal Password": "Kata sandi penarikan",
    "Security Question & Answer": "Pertanyaan dan jawaban keamanan",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Nomor telepon utama",
    "Primary Network": "Jaringan utama",
    "Second Phone Number": "Nomor telepon kedua",
    "Second Network": "Jaringan kedua",
    "Fully Secured": "Sepenuhnya aman",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Verifikasi keamanan",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Jawaban Anda",
    "Enter your answer": "Masukkan jawaban",
    "Verify Security": "Verifikasi keamanan",
    "Security Verified": "Keamanan terverifikasi",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Aman",
    "Optional": "Opsional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Pilih jaringan",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Tambah nomor kedua",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Status keamanan dompet",
    "Saved": "Tersimpan",
    "Pending": "Menunggu",
    "Added": "Ditambahkan",
    "Saving...": "Menyimpan...",
    "Save Phone Wallet": "Simpan dompet telepon",
    "Save Primary Network": "Simpan jaringan utama",
    "Save Second Network": "Simpan jaringan kedua",
    "Save Wallet Information": "Simpan informasi dompet",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Kembali",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ms": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Dompet Telefon",
    "Security setup required": "Persediaan keselamatan diperlukan",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Lengkapkan profil",
    "Mobile payment information": "Maklumat pembayaran mudah alih",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Nama sebenar",
    "Required": "Diperlukan",
    "Withdrawal Password": "Kata laluan pengeluaran",
    "Security Question & Answer": "Soalan dan jawapan keselamatan",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Nombor telefon utama",
    "Primary Network": "Rangkaian utama",
    "Second Phone Number": "Nombor telefon kedua",
    "Second Network": "Rangkaian kedua",
    "Fully Secured": "Dilindungi sepenuhnya",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Pengesahan keselamatan",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Jawapan anda",
    "Enter your answer": "Masukkan jawapan anda",
    "Verify Security": "Sahkan keselamatan",
    "Security Verified": "Keselamatan disahkan",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Dilindungi",
    "Optional": "Pilihan",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Pilih rangkaian",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Tambah nombor kedua",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Status keselamatan dompet",
    "Saved": "Disimpan",
    "Pending": "Menunggu",
    "Added": "Ditambah",
    "Saving...": "Menyimpan...",
    "Save Phone Wallet": "Simpan dompet telefon",
    "Save Primary Network": "Simpan rangkaian utama",
    "Save Second Network": "Simpan rangkaian kedua",
    "Save Wallet Information": "Simpan maklumat dompet",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Kembali",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ur": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Phone Wallet",
    "Security setup required": "Security setup required",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Complete Profile",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Required",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Optional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Saved",
    "Pending": "Pending",
    "Added": "Added",
    "Saving...": "Saving...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Go back",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "fa": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Phone Wallet",
    "Security setup required": "Security setup required",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Complete Profile",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Required",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Optional",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Saved",
    "Pending": "Pending",
    "Added": "Added",
    "Saving...": "Saving...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Go back",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "ha": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Wallet na waya",
    "Security setup required": "Ana buƙatar saitin tsaro",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Kammala bayanin martaba",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Ana buƙata",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Na zaɓi",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "An adana",
    "Pending": "Ana jira",
    "Added": "An ƙara",
    "Saving...": "Ana adanawa...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Komawa",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "yo": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Apamọwọ Foonu",
    "Security setup required": "A nilo iṣeto aabo",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Pari profaili",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Ti a nilo",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Aṣayan",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Ti fipamọ",
    "Pending": "Nduro",
    "Added": "Ti fi kun",
    "Saving...": "N fipamọ...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Pada",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "zu": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Isikhwama Sefoni",
    "Security setup required": "Kudingeka ukusetha ukuphepha",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Qedela iphrofayela",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Kuyadingeka",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Ongakukhetha",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Kulondoloziwe",
    "Pending": "Kulindile",
    "Added": "Kungeziwe",
    "Saving...": "Kuyalondolozwa...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Buyela emuva",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "am": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "የስልክ ቦርሳ",
    "Security setup required": "የደህንነት ማዋቀር ያስፈልጋል",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "መገለጫን ያጠናቅቁ",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "ያስፈልጋል",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "አማራጭ",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "ተቀምጧል",
    "Pending": "በመጠባበቅ ላይ",
    "Added": "ተጨምሯል",
    "Saving...": "በማስቀመጥ ላይ...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "ተመለስ",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "so": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Boorsada Taleefanka",
    "Security setup required": "Dejinta amniga ayaa loo baahan yahay",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Dhammaystir astaanta",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Loo baahan yahay",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Ikhtiyaari",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "La kaydiyey",
    "Pending": "Sugaya",
    "Added": "La daray",
    "Saving...": "Waa la kaydinayaa...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Dib u noqo",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "rw": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Umufuka wa telefoni",
    "Security setup required": "Hakenewe igenamiterere ry'umutekano",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Uzuza umwirondoro",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Birakenewe",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Ntibitegetswe",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Byabitswe",
    "Pending": "Birategereje",
    "Added": "Byongeweho",
    "Saving...": "Birabikwa...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Subira inyuma",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "lg": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Wallet ya ssimu",
    "Security setup required": "Kyetaagisa okuteekawo obukuumi",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Maliriza profaayiro",
    "Mobile payment information": "Mobile payment information",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Real Name",
    "Required": "Kyetaagisa",
    "Withdrawal Password": "Withdrawal Password",
    "Security Question & Answer": "Security Question & Answer",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primary Phone Number",
    "Primary Network": "Primary Network",
    "Second Phone Number": "Second Phone Number",
    "Second Network": "Second Network",
    "Fully Secured": "Fully Secured",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Security Verification",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Your Answer",
    "Enter your answer": "Enter your answer",
    "Verify Security": "Verify Security",
    "Security Verified": "Security Verified",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Secured",
    "Optional": "Kyeyagalire",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Select your network",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Add Second Number",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Wallet Security Status",
    "Saved": "Kiterekeddwa",
    "Pending": "Kirindiriddwa",
    "Added": "Kyongeddwako",
    "Saving...": "Kiterekebwa...",
    "Save Phone Wallet": "Save Phone Wallet",
    "Save Primary Network": "Save Primary Network",
    "Save Second Network": "Save Second Network",
    "Save Wallet Information": "Save Wallet Information",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Ddayo",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  },
  "af": {
    "Checking security information...": "Checking security information...",
    "Phone Wallet": "Telefoonbeursie",
    "Security setup required": "Sekuriteitsopstelling benodig",
    "Redirecting to Profile": "Redirecting to Profile",
    "You will be redirected automatically in": "You will be redirected automatically in",
    "seconds": "seconds",
    "Complete your security information there.": "Complete your security information there.",
    "Complete Profile": "Voltooi profiel",
    "Mobile payment information": "Mobiele betalingsinligting",
    "Complete Your Security Profile": "Complete Your Security Profile",
    "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
    "Real Name": "Regte naam",
    "Required": "Vereis",
    "Withdrawal Password": "Onttrekkingswagwoord",
    "Security Question & Answer": "Sekuriteitsvraag en antwoord",
    "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
    "All wallet information has been securely saved.": "All wallet information has been securely saved.",
    "Primary Phone Number": "Primêre telefoonnommer",
    "Primary Network": "Primêre netwerk",
    "Second Phone Number": "Tweede telefoonnommer",
    "Second Network": "Tweede netwerk",
    "Fully Secured": "Ten volle beveilig",
    "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
    "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
    "Wallet Setup Progress": "Wallet Setup Progress",
    "Your saved wallet information is protected.": "Your saved wallet information is protected.",
    "Primary Number": "Primary Number",
    "Not selected": "Not selected",
    "Second Number": "Second Number",
    "Not added": "Not added",
    "Security Verification": "Sekuriteitsverifikasie",
    "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
    "Your Answer": "Jou antwoord",
    "Enter your answer": "Voer jou antwoord in",
    "Verify Security": "Verifieer sekuriteit",
    "Security Verified": "Sekuriteit geverifieer",
    "You can now add your phone wallet.": "You can now add your phone wallet.",
    "Secured": "Beveilig",
    "Optional": "Opsioneel",
    "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
    "Select your network": "Kies jou netwerk",
    "You can add this number now or later.": "You can add this number now or later.",
    "Select network for second number": "Select network for second number",
    "Select the network used by your second number.": "Select the network used by your second number.",
    "Add a second number first.": "Add a second number first.",
    "Add Second Number": "Voeg tweede nommer by",
    "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
    "Wallet Security Status": "Beursie-sekuriteitstatus",
    "Saved": "Gestoor",
    "Pending": "Hangende",
    "Added": "Bygevoeg",
    "Saving...": "Stoor...",
    "Save Phone Wallet": "Stoor telefoonbeursie",
    "Save Primary Network": "Stoor primêre netwerk",
    "Save Second Network": "Stoor tweede netwerk",
    "Save Wallet Information": "Stoor beursie-inligting",
    "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
    "Go back": "Terug",
    "Failed to load wallet information.": "Failed to load wallet information.",
    "Security information is unavailable.": "Security information is unavailable.",
    "Please enter your security answer.": "Please enter your security answer.",
    "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
    "Security verified successfully.": "Security verified successfully.",
    "Please log in again.": "Please log in again.",
    "Please complete your security profile first.": "Please complete your security profile first.",
    "Please complete security verification first.": "Please complete security verification first.",
    "Please enter your primary phone number.": "Please enter your primary phone number.",
    "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
    "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
    "Please enter a valid second phone number.": "Please enter a valid second phone number.",
    "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
    "Please select the network for your second phone number.": "Please select the network for your second phone number.",
    "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
    "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
    "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
    "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
    "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
    "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again."
  }
};

const getAppLanguage = () => {
  const candidates = [
    localStorage.getItem("language"),
    localStorage.getItem("appLanguage"),
    localStorage.getItem("lang"),
  ].filter(Boolean);
  const candidate = candidates[0] || "en";
  return ADD_CARD_TRANSLATIONS[candidate] ? candidate : "en";
};

const t = (key) => {
  const language = getAppLanguage();
  return ADD_CARD_TRANSLATIONS[language]?.[key] || ADD_CARD_TRANSLATIONS.en[key] || key;
};

/* =========================================================
   MOBILE NETWORKS
========================================================= */

const mobileNetworks = [

  {
    value: "Vodacom / M-Pesa",
    label: "Vodacom / M-Pesa",
  },

  {
    value: "Airtel",
    label: "Airtel",
  },

  {
    value: "Tigo",
    label: "Tigo",
  },

  {
    value: "Halotel",
    label: "Halotel",
  },

];


/* =========================================================
   MASK PHONE NUMBER

   0758585858
   =>
   075**5858
========================================================= */

const maskPhoneNumber = (
  phone
) => {

  const value =
    String(
      phone || ""
    )
      .replace(
        /\s/g,
        ""
      )
      .replace(
        /-/g,
        ""
      )
      .trim();


  if (
    !value
  ) {

    return "";

  }


  if (
    value.length <= 7
  ) {

    return value;

  }


  const firstThree =
    value.slice(
      0,
      3
    );


  const lastFour =
    value.slice(
      -4
    );


  return (
    firstThree +
    "**" +
    lastFour
  );

};


/* =========================================================
   CLEAN PHONE NUMBER
========================================================= */

const cleanPhoneNumber = (
  value
) => {

  return String(
    value || ""
  )
    .replace(
      /[\s-]/g,
      ""
    )
    .trim();

};


/* =========================================================
   PHONE VALIDATION
========================================================= */

const isValidPhone = (
  value
) => {

  const phone =
    cleanPhoneNumber(
      value
    );


  const digitsOnly =
    phone.replace(
      /\+/g,
      ""
    );


  return (
    /^\d+$/.test(
      digitsOnly
    ) &&
    digitsOnly.length >= 9
  );

};


/* =========================================================
   ADD CARD
========================================================= */

export default function AddCard() {

  const [, setLanguageVersion] = useState(0);

  useEffect(() => {
    const refreshLanguage = () => setLanguageVersion((version) => version + 1);
    window.addEventListener("languageChanged", refreshLanguage);
    window.addEventListener("storage", refreshLanguage);
    return () => {
      window.removeEventListener("languageChanged", refreshLanguage);
      window.removeEventListener("storage", refreshLanguage);
    };
  }, []);

  const navigate =
    useNavigate();


  /* =======================================================
     USERNAME
  ======================================================= */

  const username =
    localStorage.getItem(
      "username"
    ) || "";


  /* =======================================================
     LOADING
  ======================================================= */

  const [
    loading,
    setLoading,
  ] = useState(true);


  /* =======================================================
     PROFILE COMPLETE
  ======================================================= */

  const [
    profileComplete,
    setProfileComplete,
  ] = useState(false);


  /* =======================================================
     SECURITY DATA
  ======================================================= */

  const [
    securityData,
    setSecurityData,
  ] = useState(null);


  /* =======================================================
     SECURITY VERIFIED
  ======================================================= */

  const [
    securityVerified,
    setSecurityVerified,
  ] = useState(false);


  /* =======================================================
     SECURITY ANSWER
  ======================================================= */

  const [
    securityAnswer,
    setSecurityAnswer,
  ] = useState("");


  /* =======================================================
     PRIMARY PHONE
  ======================================================= */

  const [
    phoneNumber1,
    setPhoneNumber1,
  ] = useState("");


  /* =======================================================
     SECOND PHONE
  ======================================================= */

  const [
    phoneNumber2,
    setPhoneNumber2,
  ] = useState("");


  /* =======================================================
     PRIMARY NETWORK
  ======================================================= */

  const [
    network1,
    setNetwork1,
  ] = useState("");


  /* =======================================================
     SECOND NETWORK
  ======================================================= */

  const [
    network2,
    setNetwork2,
  ] = useState("");


  /* =======================================================
     PRIMARY PHONE SAVED
  ======================================================= */

  const [
    primaryPhoneSaved,
    setPrimaryPhoneSaved,
  ] = useState(false);


  /* =======================================================
     PRIMARY NETWORK SAVED
  ======================================================= */

  const [
    network1Saved,
    setNetwork1Saved,
  ] = useState(false);


  /* =======================================================
     SECOND PHONE SAVED
  ======================================================= */

  const [
    secondPhoneSaved,
    setSecondPhoneSaved,
  ] = useState(false);


  /* =======================================================
     SECOND NETWORK SAVED
  ======================================================= */

  const [
    network2Saved,
    setNetwork2Saved,
  ] = useState(false);


  /* =======================================================
     WALLET FULLY SECURED
  ======================================================= */

  const [
    walletSecured,
    setWalletSecured,
  ] = useState(false);


  /* =======================================================
     SAVING
  ======================================================= */

  const [
    saving,
    setSaving,
  ] = useState(false);


  /* =======================================================
     MESSAGE
  ======================================================= */

  const [
    message,
    setMessage,
  ] = useState("");


  /* =======================================================
     MESSAGE TYPE
  ======================================================= */

  const [
    messageType,
    setMessageType,
  ] = useState("error");


  /* =======================================================
     REDIRECT COUNTDOWN
  ======================================================= */

  const [
    redirectCountdown,
    setRedirectCountdown,
  ] = useState(null);


  /* =======================================================
     REDIRECTING
  ======================================================= */

  const [
    redirecting,
    setRedirecting,
  ] = useState(false);


  /* =======================================================
     SHOW MESSAGE
  ======================================================= */

  const showMessage = (
    text,
    type = "error"
  ) => {

    setMessage(
      text
    );

    setMessageType(
      type
    );

  };


  /* =======================================================
     CLEAR MESSAGE
  ======================================================= */

  const clearMessage = () => {

    setMessage(
      ""
    );

  };


  /* =======================================================
     GO PROFILE
  ======================================================= */

  const handleGoToProfile = () => {

    navigate(
      "/profile",
      {
        replace: true,
      }
    );

  };


  /* =======================================================
     START PROFILE REDIRECT
  ======================================================= */

  const startProfileRedirect = () => {

    setRedirecting(
      true
    );

    setRedirectCountdown(
      10
    );

  };


  /* =======================================================
     REDIRECT COUNTDOWN
  ======================================================= */

  useEffect(() => {

    if (
      !redirecting
    ) {

      return;

    }


    if (
      redirectCountdown ===
      null
    ) {

      return;

    }


    if (
      redirectCountdown <=
      0
    ) {

      navigate(
        "/profile",
        {
          replace: true,
        }
      );

      return;

    }


    const timer =
      setTimeout(
        () => {

          setRedirectCountdown(
            previous => {

              if (
                previous ===
                null
              ) {

                return null;

              }


              return (
                previous - 1
              );

            }
          );

        },
        1000
      );


    return () => {

      clearTimeout(
        timer
      );

    };

  }, [
    redirecting,
    redirectCountdown,
    navigate,
  ]);


  /* =======================================================
     LOAD PROFILE + WALLET
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const loadData =
      async () => {

        try {

          if (
            !mounted
          ) {

            return;

          }


          setLoading(
            true
          );


          clearMessage();


          /* ===============================================
             LOGIN CHECK
          =============================================== */

          if (
            !username
          ) {

            navigate(
              "/login",
              {
                replace: true,
              }
            );

            return;

          }


          /* ===============================================
             SECURITY PROFILE
          =============================================== */

          const securityRef =
            doc(
              db,
              "security",
              username
            );


          const securitySnapshot =
            await getDoc(
              securityRef
            );


          /* ===============================================
             SECURITY PROFILE NOT FOUND
          =============================================== */

          if (
            !securitySnapshot.exists()
          ) {

            if (
              mounted
            ) {

              setSecurityData(
                null
              );

              setProfileComplete(
                false
              );

              setLoading(
                false
              );

              startProfileRedirect();

            }


            return;

          }


          /* ===============================================
             SECURITY DATA
          =============================================== */

          const security =
            securitySnapshot.data();


          if (
            !mounted
          ) {

            return;

          }


          setSecurityData(
            security
          );


          /* ===============================================
             CHECK REAL NAME
          =============================================== */

          const hasRealName =
            Boolean(
              security.realName &&
              String(
                security.realName
              ).trim()
            );


          /* ===============================================
             CHECK WITHDRAWAL PASSWORD
          =============================================== */

          const hasWithdrawalPassword =
            Boolean(
              security.withdrawPassword &&
              String(
                security.withdrawPassword
              ).trim()
            );


          /* ===============================================
             CHECK SECURITY QUESTION
          =============================================== */

          const hasSecurityQuestion =
            Boolean(
              security.securityQuestion &&
              String(
                security.securityQuestion
              ).trim()
            );


          /* ===============================================
             CHECK SECURITY ANSWER
          =============================================== */

          const hasSecurityAnswer =
            Boolean(
              security.securityAnswer &&
              String(
                security.securityAnswer
              ).trim()
            );


          /* ===============================================
             PROFILE COMPLETE
          =============================================== */

          const complete =
            hasRealName &&
            hasWithdrawalPassword &&
            hasSecurityQuestion &&
            hasSecurityAnswer;


          setProfileComplete(
            complete
          );


          /* ===============================================
             PROFILE NOT COMPLETE
          =============================================== */

          if (
            !complete
          ) {

            setLoading(
              false
            );

            startProfileRedirect();

            return;

          }


          /* ===============================================
             PHONE WALLET
          =============================================== */

          const phoneWalletRef =
            doc(
              db,
              "phoneWallet",
              username
            );


          const phoneWalletSnapshot =
            await getDoc(
              phoneWalletRef
            );


          /* ===============================================
             NO WALLET
          =============================================== */

          if (
            !phoneWalletSnapshot.exists()
          ) {

            setPhoneNumber1(
              ""
            );

            setPhoneNumber2(
              ""
            );

            setNetwork1(
              ""
            );

            setNetwork2(
              ""
            );

            setPrimaryPhoneSaved(
              false
            );

            setNetwork1Saved(
              false
            );

            setSecondPhoneSaved(
              false
            );

            setNetwork2Saved(
              false
            );

            setWalletSecured(
              false
            );

            setSecurityVerified(
              false
            );

            return;

          }


          /* ===============================================
             EXISTING WALLET
          =============================================== */

          const wallet =
            phoneWalletSnapshot.data();


          /* ===============================================
             LOAD PRIMARY PHONE
          =============================================== */

          const savedPhone1 =
            String(
              wallet.phoneNumber1 ||
              ""
            ).trim();


          /* ===============================================
             LOAD SECOND PHONE
          =============================================== */

          const savedPhone2 =
            String(
              wallet.phoneNumber2 ||
              ""
            ).trim();


          /* ===============================================
             LOAD PRIMARY NETWORK
          =============================================== */

          const savedNetwork1 =
            String(
              wallet.network1 ||
              ""
            ).trim();


          /* ===============================================
             LOAD SECOND NETWORK
          =============================================== */

          const savedNetwork2 =
            String(
              wallet.network2 ||
              ""
            ).trim();


          /* ===============================================
             LOAD VALUES
          =============================================== */

          setPhoneNumber1(
            savedPhone1
          );


          setPhoneNumber2(
            savedPhone2
          );


          setNetwork1(
            savedNetwork1
          );


          setNetwork2(
            savedNetwork2
          );


          /* ===============================================
             SAVED FLAGS
          =============================================== */

          const hasPrimary =
            Boolean(
              savedPhone1
            );


          const hasSecond =
            Boolean(
              savedPhone2
            );


          const hasNetwork1 =
            Boolean(
              savedNetwork1
            );


          const hasNetwork2 =
            Boolean(
              savedNetwork2
            );


          setPrimaryPhoneSaved(
            hasPrimary
          );


          setSecondPhoneSaved(
            hasSecond
          );


          setNetwork1Saved(
            hasNetwork1
          );


          setNetwork2Saved(
            hasNetwork2
          );


          /* ===============================================
             FULLY SECURED

             Primary
             +
             Primary Network
             +
             Second
             +
             Second Network
          =============================================== */

          const fullySecured =
            hasPrimary &&
            hasNetwork1 &&
            hasSecond &&
            hasNetwork2;


          setWalletSecured(
            fullySecured
          );


          /* ===============================================
             SECURITY VERIFICATION

             Kama primary tayari ipo,
             security question haiulizwi tena.
          =============================================== */

          setSecurityVerified(
            hasPrimary
          );

        } catch (
          error
        ) {

          console.error(
            "Add card loading error:",
            error
          );


          if (
            mounted
          ) {

            showMessage(
              t("Failed to load wallet information.")
            );

          }

        } finally {

          if (
            mounted
          ) {

            setLoading(
              false
            );

          }

        }

      };


    loadData();


    return () => {

      mounted = false;

    };

  }, [
    username,
    navigate,
  ]);


  /* =======================================================
     BACK
  ======================================================= */

  const handleBack = () => {

    navigate(
      -1
    );

  };


  /* =======================================================
     VERIFY SECURITY
  ======================================================= */

  const handleVerifySecurity =
    () => {

      clearMessage();


      if (
        !securityData
      ) {

        showMessage(
          t("Security information is unavailable.")
        );

        return;

      }


      const enteredAnswer =
        String(
          securityAnswer || ""
        )
          .trim()
          .toLowerCase();


      const correctAnswer =
        String(
          securityData.securityAnswer ||
          ""
        )
          .trim()
          .toLowerCase();


      if (
        !enteredAnswer
      ) {

        showMessage(
          t("Please enter your security answer.")
        );

        return;

      }


      if (
        enteredAnswer !==
        correctAnswer
      ) {

        showMessage(
          t("Incorrect security answer. Please try again.")
        );

        return;

      }


      setSecurityVerified(
        true
      );


      setSecurityAnswer(
        ""
      );


      showMessage(
        t("Security verified successfully."),
        "success"
      );

    };


  /* =======================================================
     PRIMARY PHONE CHANGE
     PRIMARY IKISHA SAVE HAIWEZI KUBADILISHWA
  ======================================================= */

  const handlePhoneNumber1Change = (
    event
  ) => {

    if (
      primaryPhoneSaved
    ) {

      return;

    }


    setPhoneNumber1(
      event.target.value
    );


    clearMessage();

  };


  /* =======================================================
     SECOND PHONE CHANGE
  ======================================================= */

  const handlePhoneNumber2Change = (
    event
  ) => {

    if (
      secondPhoneSaved
    ) {

      return;

    }


    setPhoneNumber2(
      event.target.value
    );


    clearMessage();

  };


  /* =======================================================
     PRIMARY NETWORK CHANGE
  ======================================================= */

  const handleNetwork1Change = (
    event
  ) => {

    if (
      network1Saved
    ) {

      return;

    }


    setNetwork1(
      event.target.value
    );


    clearMessage();

  };


  /* =======================================================
     SECOND NETWORK CHANGE
  ======================================================= */

  const handleNetwork2Change = (
    event
  ) => {

    if (
      network2Saved
    ) {

      return;

    }


    setNetwork2(
      event.target.value
    );


    clearMessage();

  };


  /* =======================================================
     SAVE WALLET
     
     Inaweza kusave:
     
     1. Primary Number
     2. Primary Network
     3. Second Number
     4. Second Network
     
     kwa hatua tofauti.
  ======================================================= */

  const handleSave =
    async () => {

      clearMessage();


      if (
        saving
      ) {

        return;

      }


      setSaving(
        true
      );


      /* ===============================================
         LOGIN
      =============================================== */

      if (
        !username
      ) {

        setSaving(
          false
        );

        showMessage(
          t("Please log in again.")
        );

        return;

      }


      /* ===============================================
         PROFILE
      =============================================== */

      if (
        !profileComplete
      ) {

        setSaving(
          false
        );

        showMessage(
          t("Please complete your security profile first.")
        );

        return;

      }


      /* ===============================================
         SECURITY
      =============================================== */

      if (
        !securityVerified
      ) {

        setSaving(
          false
        );

        showMessage(
          t("Please complete security verification first.")
        );

        return;

      }


      /* ===============================================
         CLEAN VALUES
      =============================================== */

      const enteredPhone1 =
        cleanPhoneNumber(
          phoneNumber1
        );


      const enteredPhone2 =
        cleanPhoneNumber(
          phoneNumber2
        );


      const enteredNetwork1 =
        String(
          network1 || ""
        ).trim();


      const enteredNetwork2 =
        String(
          network2 || ""
        ).trim();


      try {

        /* =============================================
           FIRESTORE REFERENCE
        ============================================= */

        const phoneWalletRef =
          doc(
            db,
            "phoneWallet",
            username
          );


        /* =============================================
           FINAL FIRESTORE CHECK
        ============================================= */

        const latestSnapshot =
          await getDoc(
            phoneWalletRef
          );


        let latestWallet =
          {};


        if (
          latestSnapshot.exists()
        ) {

          latestWallet =
            latestSnapshot.data();

        }


        /* =============================================
           LATEST PRIMARY PHONE
        ============================================= */

        const latestPhone1 =
          String(
            latestWallet.phoneNumber1 ||
            ""
          ).trim();


        /* =============================================
           LATEST SECOND PHONE
        ============================================= */

        const latestPhone2 =
          String(
            latestWallet.phoneNumber2 ||
            ""
          ).trim();


        /* =============================================
           LATEST PRIMARY NETWORK
        ============================================= */

        const latestNetwork1 =
          String(
            latestWallet.network1 ||
            ""
          ).trim();


        /* =============================================
           LATEST SECOND NETWORK
        ============================================= */

        const latestNetwork2 =
          String(
            latestWallet.network2 ||
            ""
          ).trim();


        /* =============================================
           FINAL PRIMARY PHONE

           Firestore primary always wins.
        ============================================= */

        const finalPhone1 =
          latestPhone1 ||
          enteredPhone1;


        /* =============================================
           FINAL SECOND PHONE
        ============================================= */

        const finalPhone2 =
          latestPhone2 ||
          enteredPhone2;


        /* =============================================
           FINAL PRIMARY NETWORK
        ============================================= */

        const finalNetwork1 =
          latestNetwork1 ||
          enteredNetwork1;


        /* =============================================
           FINAL SECOND NETWORK
        ============================================= */

        const finalNetwork2 =
          latestNetwork2 ||
          enteredNetwork2;


        /* =============================================
           PRIMARY REQUIRED
        ============================================= */

        if (
          !finalPhone1
        ) {

          setSaving(
            false
          );

          showMessage(
            t("Please enter your primary phone number.")
          );

          return;

        }


        /* =============================================
           PRIMARY VALIDATION
        ============================================= */

        if (
          !isValidPhone(
            finalPhone1
          )
        ) {

          setSaving(
            false
          );

          showMessage(
            t("Please enter a valid primary phone number.")
          );

          return;

        }


        /* =============================================
           PRIMARY NETWORK REQUIRED
        ============================================= */

        if (
          !finalNetwork1
        ) {

          setSaving(
            false
          );

          showMessage(
            t("Please select the network for your primary phone number.")
          );

          return;

        }


        /* =============================================
           SECOND PHONE VALIDATION
        ============================================= */

        if (
          finalPhone2 &&
          !isValidPhone(
            finalPhone2
          )
        ) {

          setSaving(
            false
          );

          showMessage(
            t("Please enter a valid second phone number.")
          );

          return;

        }


        /* =============================================
           SAME NUMBER CHECK
        ============================================= */

        if (
          finalPhone2 &&
          finalPhone1 ===
          finalPhone2
        ) {

          setSaving(
            false
          );

          showMessage(
            t("The second phone number must be different from the primary number.")
          );

          return;

        }


        /* =============================================
           SECOND NETWORK REQUIRED
           
           ONLY IF SECOND NUMBER EXISTS
        ============================================= */

        if (
          finalPhone2 &&
          !finalNetwork2
        ) {

          setSaving(
            false
          );

          showMessage(
            t("Please select the network for your second phone number.")
          );

          return;

        }


        /* =============================================
           FINAL STATUS
        ============================================= */

        const finalHasPrimary =
          Boolean(
            finalPhone1
          );


        const finalHasNetwork1 =
          Boolean(
            finalNetwork1
          );


        const finalHasSecond =
          Boolean(
            finalPhone2
          );


        const finalHasNetwork2 =
          Boolean(
            finalNetwork2
          );


        /* =============================================
           FULLY SECURED
           
           SECOND NUMBER IS REQUIRED FOR FULL STATUS
        ============================================= */

        const fullySecured =
          finalHasPrimary &&
          finalHasNetwork1 &&
          finalHasSecond &&
          finalHasNetwork2;


        /* =============================================
           SAVE FIRESTORE
        ============================================= */

        await setDoc(
          phoneWalletRef,
          {

            username,

            phoneNumber1:
              finalPhone1,

            network1:
              finalNetwork1,

            phoneNumber2:
              finalPhone2,

            network2:
              finalNetwork2,

            primaryPhoneSecured:
              finalHasPrimary,

            primaryNetworkSelected:
              finalHasNetwork1,

            secondPhoneAdded:
              finalHasSecond,

            secondNetworkSelected:
              finalHasNetwork2,

            walletSecured:
              fullySecured,

            updatedAt:
              new Date(),

          },
          {
            merge: true,
          }
        );


        /* =============================================
           UPDATE LOCAL STATE
        ============================================= */

        setPhoneNumber1(
          finalPhone1
        );


        setPhoneNumber2(
          finalPhone2
        );


        setNetwork1(
          finalNetwork1
        );


        setNetwork2(
          finalNetwork2
        );


        setPrimaryPhoneSaved(
          finalHasPrimary
        );


        setNetwork1Saved(
          finalHasNetwork1
        );


        setSecondPhoneSaved(
          finalHasSecond
        );


        setNetwork2Saved(
          finalHasNetwork2
        );


        setWalletSecured(
          fullySecured
        );


        /* =============================================
           SECURITY REMAINS VERIFIED
        ============================================= */

        setSecurityVerified(
          true
        );


        /* =============================================
           SUCCESS MESSAGE
        ============================================= */

        if (
          fullySecured
        ) {

          showMessage(
            t("Phone wallet fully secured successfully."),
            "success"
          );

        } else if (
          finalHasPrimary &&
          finalHasNetwork1 &&
          !finalHasSecond
        ) {

          showMessage(
            t("Primary number and network saved. You can add a second number anytime."),
            "success"
          );

        } else if (
          finalHasPrimary &&
          !finalHasNetwork1
        ) {

          showMessage(
            t("Primary number saved. Please select its mobile network."),
            "success"
          );

        } else if (
          finalHasSecond &&
          !finalHasNetwork2
        ) {

          showMessage(
            t("Second number saved. Please select its mobile network."),
            "success"
          );

        } else {

          showMessage(
            t("Phone wallet information saved successfully."),
            "success"
          );

        }

      } catch (
        error
      ) {

        console.error(
          "Phone wallet save error:",
          error
        );


        showMessage(
          t("Failed to save phone wallet information. Please try again.")
        );

      } finally {

        setSaving(
          false
        );

      }

    };


  /* =======================================================
     ENTER KEY - SECURITY
  ======================================================= */

  const handleSecurityKeyDown = (
    event
  ) => {

    if (
      event.key ===
      "Enter"
    ) {

      handleVerifySecurity();

    }

  };


  /* =======================================================
     ENTER KEY - PHONE
  ======================================================= */

  const handlePhoneKeyDown = (
    event
  ) => {

    if (
      event.key ===
      "Enter"
    ) {

      handleSave();

    }

  };


  /* =======================================================
     LOADING SCREEN
  ======================================================= */

  if (
    loading
  ) {

    return (

      <div className="phone-wallet-page">

        <div className="phone-wallet-loading">

          <FaSpinner
            className="phone-wallet-spinner"
          />

          <span>{t("Checking security information...")}</span>

        </div>

      </div>

    );

  }


  /* =======================================================
     REDIRECT SCREEN
  ======================================================= */

  if (
    redirecting &&
    !profileComplete
  ) {

    return (

      <div className="phone-wallet-page">

        <div className="phone-wallet-container phone-wallet-redirect-container">


          <div className="phone-wallet-header">

            <button
              type="button"
              className="phone-wallet-back"
              onClick={
                handleBack
              }
              aria-label={t("Go back")}
            >

              <FaArrowLeft />

            </button>


            <div>

              <h1>{t("Phone Wallet")}</h1>


              <span>{t("Security setup required")}</span>

            </div>

          </div>


          <div className="phone-wallet-redirect-card">

            <div className="phone-wallet-redirect-icon">

              <FaSpinner
                className="phone-wallet-spinner"
              />

            </div>


            <div className="phone-wallet-redirect-content">

              <strong>{t("Redirecting to Profile")}</strong>


              <span>{t("You will be redirected automatically in")}</span>


              <div className="phone-wallet-countdown">

                {
                  redirectCountdown
                }

              </div>


              <small>{t("seconds")}</small>


              <small>{t("Complete your security information there.")}</small>

            </div>

          </div>


          <button
            type="button"
            className="phone-wallet-profile-btn"
            onClick={
              handleGoToProfile
            }
          >{t("Complete Profile")}</button>

        </div>

      </div>

    );

  }


  /* =======================================================
     PROFILE NOT COMPLETE
  ======================================================= */

  if (
    !profileComplete
  ) {

    return (

      <div className="phone-wallet-page">

        <div className="phone-wallet-container">


          <div className="phone-wallet-header">

            <button
              type="button"
              className="phone-wallet-back"
              onClick={
                handleBack
              }
              aria-label={t("Go back")}
            >

              <FaArrowLeft />

            </button>


            <div>

              <h1>{t("Phone Wallet")}</h1>


              <span>{t("Security setup required")}</span>

            </div>

          </div>


          <div className="phone-wallet-security-card">

            <FaShieldAlt />


            <div>

              <strong>{t("Complete Your Security Profile")}</strong>


              <p>{t("Before adding a phone wallet, please complete the required security information in your profile.")}</p>

            </div>

          </div>


          <div className="phone-wallet-requirements">

            <div className="phone-wallet-requirement">

              <span>{t("Real Name")}</span>


              <span>{t("Required")}</span>

            </div>


            <div className="phone-wallet-requirement">

              <span>{t("Withdrawal Password")}</span>


              <span>{t("Required")}</span>

            </div>


            <div className="phone-wallet-requirement">

              <span>{t("Security Question & Answer")}</span>


              <span>{t("Required")}</span>

            </div>

          </div>


          <button
            type="button"
            className="phone-wallet-profile-btn"
            onClick={
              handleGoToProfile
            }
          >{t("Complete Profile")}</button>

        </div>

      </div>

    );

  }


  /* =======================================================
     FULLY SECURED SCREEN
  ======================================================= */

  if (
    walletSecured
  ) {

    return (

      <div className="phone-wallet-page">

        <div className="phone-wallet-container">


          <div className="phone-wallet-header">

            <button
              type="button"
              className="phone-wallet-back"
              onClick={
                handleBack
              }
              aria-label={t("Go back")}
            >

              <FaArrowLeft />

            </button>


            <div>

              <h1>{t("Phone Wallet")}</h1>


              <span>{t("Mobile payment information")}</span>

            </div>

          </div>


          <div className="phone-wallet-secured-card">


            <div className="phone-wallet-secured-header">

              <div className="phone-wallet-secured-icon">

                <FaCheckCircle />

              </div>


              <div>

                <strong>{t("Phone Wallet Fully Secured")}</strong>


                <span>{t("All wallet information has been securely saved.")}</span>

              </div>

            </div>


            {/* PRIMARY PHONE */}

            <div className="phone-wallet-detail">

              <div className="phone-wallet-detail-icon">

                <FaPhone />

              </div>


              <div className="phone-wallet-detail-content">

                <span>{t("Primary Phone Number")}</span>


                <strong>
                  {
                    maskPhoneNumber(
                      phoneNumber1
                    )
                  }
                </strong>

              </div>


              <FaCheckCircle
                className="phone-wallet-detail-check"
              />

            </div>


            {/* PRIMARY NETWORK */}

            <div className="phone-wallet-detail">

              <div className="phone-wallet-detail-icon">

                <FaNetworkWired />

              </div>


              <div className="phone-wallet-detail-content">

                <span>{t("Primary Network")}</span>


                <strong>
                  {
                    network1
                  }
                </strong>

              </div>


              <FaCheckCircle
                className="phone-wallet-detail-check"
              />

            </div>


            {/* SECOND PHONE */}

            <div className="phone-wallet-detail">

              <div className="phone-wallet-detail-icon">

                <FaMobileAlt />

              </div>


              <div className="phone-wallet-detail-content">

                <span>{t("Second Phone Number")}</span>


                <strong>
                  {
                    maskPhoneNumber(
                      phoneNumber2
                    )
                  }
                </strong>

              </div>


              <FaCheckCircle
                className="phone-wallet-detail-check"
              />

            </div>


            {/* SECOND NETWORK */}

            <div className="phone-wallet-detail">

              <div className="phone-wallet-detail-icon">

                <FaNetworkWired />

              </div>


              <div className="phone-wallet-detail-content">

                <span>{t("Second Network")}</span>


                <strong>
                  {
                    network2
                  }
                </strong>

              </div>


              <FaCheckCircle
                className="phone-wallet-detail-check"
              />

            </div>


            {/* STATUS */}

            <div className="phone-wallet-secured-status">

              <FaCheckCircle />


              <div>

                <strong>{t("Fully Secured")}</strong>


                <span>{t("Primary number, primary network, second number and second network are saved.")}</span>

              </div>

            </div>


            {/* LOCK */}

            <div className="phone-wallet-locked">

              <FaLock />


              <span>{t("This wallet information is secured and cannot be edited.")}</span>

            </div>


          </div>

        </div>

      </div>

    );

  }


  /* =======================================================
     MAIN PAGE
  ======================================================= */

  return (

    <div className="phone-wallet-page">

      <div className="phone-wallet-container">


        {/* =================================================
            HEADER
        ================================================= */}

        <div className="phone-wallet-header">

          <button
            type="button"
            className="phone-wallet-back"
            onClick={
              handleBack
            }
            aria-label={t("Go back")}
          >

            <FaArrowLeft />

          </button>


          <div>

            <h1>{t("Phone Wallet")}</h1>


            <span>{t("Mobile payment information")}</span>

          </div>

        </div>


        {/* =================================================
            PROGRESS CARD
        ================================================= */}

        {
          primaryPhoneSaved && (

            <div className="phone-wallet-progress-card">


              <div className="phone-wallet-progress-header">

                <FaCheckCircle />


                <div>

                  <strong>{t("Wallet Setup Progress")}</strong>


                  <span>{t("Your saved wallet information is protected.")}</span>

                </div>

              </div>


              <div className="phone-wallet-progress-list">


                {/* PRIMARY PHONE */}

                <div className="phone-wallet-progress-item completed">

                  <div>

                    <FaCheckCircle />

                    <span>{t("Primary Number")}</span>

                  </div>


                  <strong>
                    {
                      maskPhoneNumber(
                        phoneNumber1
                      )
                    }
                  </strong>

                </div>


                {/* PRIMARY NETWORK */}

                <div
                  className={
                    network1Saved
                      ? "phone-wallet-progress-item completed"
                      : "phone-wallet-progress-item pending"
                  }
                >

                  <div>

                    {
                      network1Saved ? (
                        <FaCheckCircle />
                      ) : (
                        <FaNetworkWired />
                      )
                    }


                    <span>{t("Primary Network")}</span>

                  </div>


                  <strong>

                    {
                      network1Saved
                        ? network1
                        : t("Not selected")
                    }

                  </strong>

                </div>


                {/* SECOND PHONE */}

                <div
                  className={
                    secondPhoneSaved
                      ? "phone-wallet-progress-item completed"
                      : "phone-wallet-progress-item pending"
                  }
                >

                  <div>

                    {
                      secondPhoneSaved ? (
                        <FaCheckCircle />
                      ) : (
                        <FaMobileAlt />
                      )
                    }


                    <span>{t("Second Number")}</span>

                  </div>


                  <strong>

                    {
                      secondPhoneSaved
                        ? maskPhoneNumber(
                            phoneNumber2
                          )
                        : t("Not added")
                    }

                  </strong>

                </div>


                {/* SECOND NETWORK */}

                <div
                  className={
                    network2Saved
                      ? "phone-wallet-progress-item completed"
                      : "phone-wallet-progress-item pending"
                  }
                >

                  <div>

                    {
                      network2Saved ? (
                        <FaCheckCircle />
                      ) : (
                        <FaNetworkWired />
                      )
                    }


                    <span>{t("Second Network")}</span>

                  </div>


                  <strong>

                    {
                      network2Saved
                        ? network2
                        : t("Not selected")
                    }

                  </strong>

                </div>


              </div>

            </div>

          )
        }


        {/* =================================================
            SECURITY VERIFICATION
        ================================================= */}

        {
          !primaryPhoneSaved &&
          !securityVerified ? (

            <div className="phone-wallet-verify-card">


              <div className="phone-wallet-verify-icon">

                <FaShieldAlt />

              </div>


              <div className="phone-wallet-verify-title">{t("Security Verification")}</div>


              <div className="phone-wallet-verify-description">{t("Please answer your security question before adding your phone wallet.")}</div>


              <div className="phone-wallet-question">

                {
                  securityData?.securityQuestion
                }

              </div>


              <div className="phone-wallet-input-group">

                <label>{t("Your Answer")}</label>


                <input
                  type="text"
                  value={
                    securityAnswer
                  }
                  onChange={
                    event =>
                      setSecurityAnswer(
                        event.target.value
                      )
                  }
                  onKeyDown={
                    handleSecurityKeyDown
                  }
                  placeholder={t("Enter your answer")}
                  autoComplete="off"
                  autoFocus
                />

              </div>


              {
                message && (

                  <div
                    className={
                      `phone-wallet-message ${messageType}`
                    }
                  >

                    {
                      message
                    }

                  </div>

                )
              }


              <button
                type="button"
                className="phone-wallet-verify-btn"
                onClick={
                  handleVerifySecurity
                }
              >

                <FaShieldAlt />{t("Verify Security")}</button>


            </div>

          ) : (


            /* =================================================
               WALLET FORM
            ================================================= */

            <div className="phone-wallet-form">


              {/* =================================================
                  SECURITY VERIFIED
              ================================================= */}

              {
                !primaryPhoneSaved && (

                  <div className="phone-wallet-verified">

                    <FaCheckCircle />


                    <div>

                      <strong>{t("Security Verified")}</strong>


                      <span>{t("You can now add your phone wallet.")}</span>

                    </div>

                  </div>

                )
              }


              {/* =================================================
                  PRIMARY PHONE
              ================================================= */}

              <div className="phone-wallet-input-group">

                <label>{t("Primary Phone Number")}<small>

                    {
                      primaryPhoneSaved
                        ? t("Secured")
                        : t("Required")
                    }

                  </small>

                </label>


                <div
                  className={
                    primaryPhoneSaved
                      ? "phone-input-box locked"
                      : "phone-input-box"
                  }
                >

                  <FaPhone />


                  <input
                    type="tel"
                    value={
                      phoneNumber1
                    }
                    onChange={
                      handlePhoneNumber1Change
                    }
                    onKeyDown={
                      handlePhoneKeyDown
                    }
                    placeholder="0758 585 858"
                    inputMode="tel"
                    autoComplete="tel"
                    disabled={
                      saving ||
                      primaryPhoneSaved
                    }
                  />


                  {
                    primaryPhoneSaved && (

                      <FaLock
                        className="phone-wallet-input-lock"
                      />

                    )
                  }

                </div>


                {
                  primaryPhoneSaved && (

                    <small className="phone-wallet-field-note">{t("Primary number is already secured and cannot be changed.")}</small>

                  )
                }

              </div>


              {/* =================================================
                  PRIMARY NETWORK
              ================================================= */}

              <div className="phone-wallet-input-group">

                <label>{t("Primary Network")}<small>

                    {
                      network1Saved
                        ? t("Secured")
                        : t("Required")
                    }

                  </small>

                </label>


                {
                  network1Saved ? (

                    <div className="phone-wallet-network-saved">

                      <FaNetworkWired />


                      <span>
                        {
                          network1
                        }
                      </span>


                      <FaCheckCircle />

                    </div>

                  ) : (

                    <div className="phone-wallet-network-select">

                      <select
                        value={
                          network1
                        }
                        onChange={
                          handleNetwork1Change
                        }
                        disabled={
                          saving
                        }
                      >

                        <option value="">{t("Select your network")}</option>


                        {
                          mobileNetworks.map(
                            item => (

                              <option
                                key={
                                  item.value
                                }
                                value={
                                  item.value
                                }
                              >

                                {
                                  item.label
                                }

                              </option>

                            )
                          )
                        }

                      </select>


                      <span className="phone-wallet-select-arrow">
                        ⌄
                      </span>

                    </div>

                  )
                }

              </div>


              {/* =================================================
                  SECOND PHONE
              ================================================= */}

              <div className="phone-wallet-input-group">

                <label>{t("Second Phone Number")}<small>

                    {
                      secondPhoneSaved
                        ? t("Secured")
                        : t("Optional")
                    }

                  </small>

                </label>


                {
                  secondPhoneSaved ? (

                    <div className="phone-wallet-network-saved">

                      <FaMobileAlt />


                      <span>
                        {
                          maskPhoneNumber(
                            phoneNumber2
                          )
                        }
                      </span>


                      <FaCheckCircle />

                    </div>

                  ) : (

                    <div className="phone-input-box">

                      <FaMobileAlt />


                      <input
                        type="tel"
                        value={
                          phoneNumber2
                        }
                        onChange={
                          handlePhoneNumber2Change
                        }
                        onKeyDown={
                          handlePhoneKeyDown
                        }
                        placeholder="0759 595 858"
                        inputMode="tel"
                        autoComplete="tel"
                        disabled={
                          saving
                        }
                      />

                    </div>

                  )
                }


                {
                  !secondPhoneSaved && (

                    <small className="phone-wallet-field-note">{t("You can add this number now or later.")}</small>

                  )
                }

              </div>

{/* =================================================
                  SECOND NETWORK
              ================================================= */}

<div className="phone-wallet-input-group">

<label>{t("Second Network")}<small>

    {
      network2Saved
        ? t("Secured")
        : phoneNumber2
          ? t("Required")
          : t("Optional")
    }

  </small>

</label>


{
  network2Saved ? (

    <div className="phone-wallet-network-saved">

      <FaNetworkWired />


      <span>
        {
          network2
        }
      </span>


      <FaCheckCircle />

    </div>

  ) : (

    <div className="phone-wallet-network-select">

      <select
        value={
          network2
        }
        onChange={
          handleNetwork2Change
        }
        disabled={
          saving ||
          !phoneNumber2
        }
      >

        <option value="">{t("Select network for second number")}</option>


        {
          mobileNetworks.map(
            item => (

              <option
                key={
                  item.value
                }
                value={
                  item.value
                }
              >

                {
                  item.label
                }

              </option>

            )
          )
        }

      </select>


      <span className="phone-wallet-select-arrow">
        ⌄
      </span>

    </div>

  )
}


{
  !network2Saved && (

    <small className="phone-wallet-field-note">

      {
        phoneNumber2
          ? t("Select the network used by your second number.")
          : t("Add a second number first.")
      }

    </small>

  )
}

</div>


{/* =================================================
  ADD SECOND NOTICE
================================================= */}

{
primaryPhoneSaved &&
!secondPhoneSaved && (

  <div className="phone-wallet-add-second-card">


    <div className="phone-wallet-add-second-icon">

      <FaPlus />

    </div>


    <div>

      <strong>{t("Add Second Number")}</strong>


      <span>{t("You can add another phone number with its own mobile network.")}</span>

    </div>

  </div>

)
}


{/* =================================================
  WALLET STATUS
================================================= */}

<div className="phone-wallet-status-card">


<div className="phone-wallet-status-title">

  <FaShieldAlt />


  <strong>{t("Wallet Security Status")}</strong>

</div>


{/* PRIMARY */}

<div className="phone-wallet-status-row">

  <span>{t("Primary Number")}</span>


  {
    primaryPhoneSaved ? (

      <b className="status-complete">

        <FaCheckCircle />{t("Saved")}</b>

    ) : (

      <b className="status-pending">{t("Pending")}</b>

    )
  }

</div>


{/* PRIMARY NETWORK */}

<div className="phone-wallet-status-row">

  <span>{t("Primary Network")}</span>


  {
    network1Saved ? (

      <b className="status-complete">

        <FaCheckCircle />{t("Saved")}</b>

    ) : (

      <b className="status-pending">{t("Pending")}</b>

    )
  }

</div>


{/* SECOND NUMBER */}

<div className="phone-wallet-status-row">

  <span>{t("Second Number")}</span>


  {
    secondPhoneSaved ? (

      <b className="status-complete">

        <FaCheckCircle />{t("Added")}</b>

    ) : (

      <b className="status-pending">{t("Optional")}</b>

    )
  }

</div>


{/* SECOND NETWORK */}

<div className="phone-wallet-status-row">

  <span>{t("Second Network")}</span>


  {
    network2Saved ? (

      <b className="status-complete">

        <FaCheckCircle />{t("Saved")}</b>

    ) : (

      <b className="status-pending">

        {
          secondPhoneSaved
            ? t("Pending")
            : t("Optional")
        }

      </b>

    )
  }

</div>


</div>


{/* =================================================
  MESSAGE
================================================= */}

{
message && (

  <div
    className={
      `phone-wallet-message ${messageType}`
    }
  >

    {
      messageType ===
      "success" && (

        <FaCheckCircle />

      )
    }


    <span>
      {
        message
      }
    </span>

  </div>

)
}


{/* =================================================
  SAVE BUTTON
================================================= */}

<button
type="button"
className="phone-wallet-save-btn"
onClick={
  handleSave
}
disabled={
  saving
}
>

{
  saving ? (

    <>

      <FaSpinner
        className="phone-wallet-button-spinner"
      />{t("Saving...")}</>

  ) : !primaryPhoneSaved ? (

    <>

      <FaSave />{t("Save Phone Wallet")}</>

  ) : !network1Saved ? (

    <>

      <FaNetworkWired />{t("Save Primary Network")}</>

  ) : !secondPhoneSaved ? (

    <>

      <FaPlus />{t("Add Second Number")}</>

  ) : !network2Saved ? (

    <>

      <FaNetworkWired />{t("Save Second Network")}</>

  ) : (

    <>

      <FaSave />{t("Save Wallet Information")}</>

  )
}

</button>


{/* =================================================
  LATER NOTE
================================================= */}

{
primaryPhoneSaved &&
!secondPhoneSaved && (

  <div className="phone-wallet-later-note">

    <FaMobileAlt />


    <span>{t("Your primary number and its network are protected. You can return anytime to add a second number and select its own network.")}</span>

  </div>

)
}


</div>

)
}


</div>

</div>

);

}

          